<a [routerLink]="['/', i18nService.language, to]" class="reverse__direction mt-2">
  <span *ngIf="preventIf; else noModal" (click)="$event.stopPropagation(); $event.preventDefault(); onClick.emit()"
    [translate]="text"></span>
  <ng-template #noModal>
    <span [translate]="text"></span>
  </ng-template>
</a>